// eslint-disable-next-line import/no-cycle
import {
  EMOTION_GET_DETAILS,
  EMOTION_GET_DETAILS_SUCCESS,
  EMOTION_GET_DETAILS_ERROR,
  EMOTION_GET_NEWEST,
  EMOTION_GET_NEWEST_SUCCESS,
  EMOTION_GET_NEWEST_ERROR,
} from '../actions';

export const emotionGetNewest = (callback) => ({
  type: EMOTION_GET_NEWEST,
  callback,
})
export const emotionGetNewestSuccessed = (data) => ({
  type: EMOTION_GET_NEWEST_SUCCESS,
  payload: data,
});
export const emotionGetNewestFailed = (error) => ({
  type: EMOTION_GET_NEWEST_ERROR,
  payload: error
});

export const emotionGetDetails = (user_id, callback) => ({
  type: EMOTION_GET_DETAILS,
  payload: { user_id },
  callback,
})
export const emotionGetDetailsSuccessed = (data) => ({
  type: EMOTION_GET_DETAILS_SUCCESS,
  payload: data,
});
export const emotionGetDetailsFailed = (error) => ({
  type: EMOTION_GET_DETAILS_ERROR,
  payload: error
});